import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { observer } from 'mobx-react';
import { Router } from 'react-router-dom';
import { createMemoryHistory, createBrowserHistory } from 'history';
import { ApolloProvider } from '@apollo/client';
import { Box } from '@utex/ui-kit';
import { I18Service } from './services/i18nservice';
import { Navigation } from './components/Navigation';
import { UserBlock } from './components/UserBlock';
import { Authentication } from './components/Authentication';
import { MenuButton } from './components/MenuButton';
import { Container, Wrapper, UserBlockContainer, HeaderBlock, Logo, logoIcon, logoText, } from './styles';
import { IconHeaderLogo, IconHeaderLogoText } from './components/Icons';
import { createApolloClient } from './services/createApolloClient';
var packageInfo = require('../package');
var i18n;
var apolloClient;
var history;
var isBrowser = function () { return typeof window !== 'undefined'; };
export var Header = observer(function (_a) {
    var isAuthorized = _a.isAuthorized, isSSR = _a.isSSR, openSideMenu = _a.openSideMenu, _b = _a.view, view = _b === void 0 ? 'default' : _b, onRegistration = _a.onRegistration, onLogin = _a.onLogin, openDepositModal = _a.openDepositModal, openWithdrawModal = _a.openWithdrawModal, locale = _a.locale, getTokens = _a.getTokens, appConfig = _a.appConfig, navigationActiveItem = _a.navigationActiveItem, navigateTo = _a.navigateTo, loginWith2FARecomendation = _a.loginWith2FARecomendation, customNavCallbacks = _a.customNavCallbacks;
    if ((!i18n && !apolloClient) || isSSR) {
        i18n = new I18Service(locale);
        apolloClient = createApolloClient(appConfig.graphqlGateway.url, getTokens);
        history = isBrowser() ? createBrowserHistory() : createMemoryHistory();
    }
    var callbacks = customNavCallbacks || {
        toIdeas: function () { return navigateTo('/investments'); },
        toPortfolio: function () { return navigateTo('/investments/open-investment'); },
        toIPO: function () { return navigateTo('/how-it-works/ipo'); },
        toPreIPO: function () { return navigateTo('/how-it-works/pre-ipo'); },
        toAccount: function () { return navigateTo('/account/usd'); },
    };
    useEffect(function () {
        apolloClient.resetStore();
    }, [isAuthorized]);
    useEffect(function () {
        i18n.update({
            getTokens: getTokens,
            locale: locale,
            appConfig: appConfig,
        });
    }, [locale]);
    var _c = useState(false), isScrolled = _c[0], setScroll = _c[1];
    var scrollHandler = function () {
        var documentScrollTop = isBrowser && document.documentElement.scrollTop;
        if (documentScrollTop >= 60 || document.body.style.position === 'fixed') {
            setScroll(true);
        }
        else {
            setScroll(false);
        }
    };
    useEffect(function () {
        console.groupCollapsed('Application header started');
        console.info('VERSION', packageInfo.version);
        console.groupEnd();
        isBrowser && window.addEventListener('scroll', scrollHandler);
        return function () {
            isBrowser && window.removeEventListener('scroll', scrollHandler);
        };
    }, []);
    return (React.createElement(Router, { history: history },
        React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(I18nextProvider, { i18n: i18n.i18next },
                React.createElement(Container, { view: view, isScrolled: isScrolled, className: "compensate-for-scrollbar" },
                    React.createElement(Wrapper, null,
                        React.createElement(HeaderBlock, { isScrolled: isScrolled, "data-testid": "header" },
                            React.createElement(Box, { minWidth: { tablesktop: 300 }, display: "flex" },
                                React.createElement(Logo, { isScrolled: isScrolled, href: '/', "data-testid": "logo-link" },
                                    React.createElement(IconHeaderLogo, { width: 34, height: 47, css: logoIcon(view, isScrolled) }),
                                    React.createElement(IconHeaderLogoText, { width: 90, height: 38, css: logoText(view, isScrolled) }))),
                            React.createElement(Navigation, { activeItem: navigationActiveItem, view: isScrolled ? 'default' : view, onIdeasClick: callbacks.toIdeas, onPortfolioClick: callbacks.toPortfolio, onIPOClick: callbacks.toIPO, onPreIPOClick: callbacks.toPreIPO }),
                            React.createElement(Box, { display: { mobile: 'none' } },
                                React.createElement(UserBlockContainer, null, isAuthorized ? (React.createElement(UserBlock, { openSideMenu: openSideMenu, view: isScrolled ? 'default' : view, openDeposit: openDepositModal, openWithdraw: openWithdrawModal, onAccountsClick: callbacks.toAccount, is2FADisabled: loginWith2FARecomendation === null || loginWith2FARecomendation === void 0 ? void 0 : loginWith2FARecomendation.isVisible })) : (React.createElement(Box, { display: "flex" },
                                    isAuthorized === false && (React.createElement(Box, { marginRight: 10 },
                                        React.createElement(Authentication, { onLogin: onLogin, onRegistration: onRegistration, view: isScrolled ? 'default' : view }))),
                                    React.createElement(MenuButton, { openSideMenu: openSideMenu, view: isScrolled ? 'default' : view }))))),
                            React.createElement(Box, { display: { all: 'none', mobile: 'block' } },
                                React.createElement(MenuButton, { openSideMenu: openSideMenu, view: view })))))))));
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/index.js
// module id = 1375
// module chunks = 118